import { configureStore } from '@reduxjs/toolkit';
import {
  serversApi,
  clientsApi,
  projectsApi,
  servicesApi,
  metricsApiSlice,
  mysqlApi,
  proyectoServidorApi,
  roadmapApi,
  urlMonitorApi,
  sslMonitorApi,
  dominiosApi,
  alertasApi,
  bitacoraApi,
  reportesApi,
  proyectoDetalleApi,
  ollamaApi,
  serverProcessesApi,
  syncStatusApi,
  dnsStatusApi,
  appsApi,
} from './api';
import authReducer from './authSlice';
import uiReducer from './uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    [serversApi.reducerPath]: serversApi.reducer,
    [clientsApi.reducerPath]: clientsApi.reducer,
    [projectsApi.reducerPath]: projectsApi.reducer,
    [servicesApi.reducerPath]: servicesApi.reducer,
    [metricsApiSlice.reducerPath]: metricsApiSlice.reducer,
    [mysqlApi.reducerPath]: mysqlApi.reducer,
    [proyectoServidorApi.reducerPath]: proyectoServidorApi.reducer,
    [roadmapApi.reducerPath]: roadmapApi.reducer,
    [urlMonitorApi.reducerPath]: urlMonitorApi.reducer,
    [sslMonitorApi.reducerPath]: sslMonitorApi.reducer,
    [dominiosApi.reducerPath]: dominiosApi.reducer,
    [alertasApi.reducerPath]: alertasApi.reducer,
    [bitacoraApi.reducerPath]: bitacoraApi.reducer,
    [reportesApi.reducerPath]: reportesApi.reducer,
    [proyectoDetalleApi.reducerPath]: proyectoDetalleApi.reducer,
    [ollamaApi.reducerPath]: ollamaApi.reducer,
    [serverProcessesApi.reducerPath]: serverProcessesApi.reducer,
    [syncStatusApi.reducerPath]: syncStatusApi.reducer,
    [dnsStatusApi.reducerPath]: dnsStatusApi.reducer,
    [appsApi.reducerPath]: appsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(serversApi.middleware)
      .concat(clientsApi.middleware)
      .concat(projectsApi.middleware)
      .concat(servicesApi.middleware)
      .concat(metricsApiSlice.middleware)
      .concat(mysqlApi.middleware)
      .concat(proyectoServidorApi.middleware)
      .concat(roadmapApi.middleware)
      .concat(urlMonitorApi.middleware)
      .concat(sslMonitorApi.middleware)
      .concat(dominiosApi.middleware)
      .concat(alertasApi.middleware)
      .concat(bitacoraApi.middleware)
      .concat(reportesApi.middleware)
      .concat(proyectoDetalleApi.middleware)
      .concat(ollamaApi.middleware)
      .concat(serverProcessesApi.middleware)
      .concat(syncStatusApi.middleware)
      .concat(dnsStatusApi.middleware)
      .concat(appsApi.middleware),
});

export default store;
